// 主機頁的〔遠端協助〕（SPEC #kinio-kms-remote「操作者流程」：主機頁或協助請求〔遠端協助〕→ 選權限…）。
// 沒有這台的遠端協助權限（主機清單的 can_remote = false，kmgr M4-06b）就不畫（UX-11）；這台不能發起時按鈕停用並在旁邊寫原因；
// 自己有進行中的 →〔回到遠端協助〕（讀這台最近 5 筆紀錄）。
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { NS } from '../parts';
import type { HostRow } from '../types';
import { useKmgrEnv } from '../hooks';
import { remoteApi } from './api';
import { hostBlock } from './model';
import { RemoteDialog } from './RemoteDialog';
import { isPhone, targetOf } from './target';

export function HostRemoteButton({ h, api }: { h: HostRow; api: string }) {
  const { t } = useTranslation(NS);
  const { me } = useKmgrEnv();
  const [open, setOpen] = useState<{ resume?: string } | null>(null);
  const q = useQuery({
    queryKey: ['kmgr', 'remote', 'device', h.home_id, h.target_ref],
    queryFn: async () => (await remoteApi.listDevice(api, h.home_id, h.target_ref, undefined, 5)).sessions,
    enabled: !!api && h.can_remote === true,
    staleTime: 10_000,
    refetchInterval: open ? false : 30_000,
  });
  if (h.can_remote !== true) return null;
  const mine = q.data?.find((s) => s.state !== 'ended' && s.operator === me);
  // 手機不能發起（遠端工具只有 Windows / macOS / Linux；SPEC「App 不能發起：請在電腦上開始遠端協助」）
  const block = isPhone() ? 'phone' : hostBlock(h);
  const target = targetOf(h, { home_id: h.home_id, device_ref: h.target_ref }, api);
  return (
    <>
      {mine ? (
        <button className="btn btn-sm btn-primary" onClick={() => setOpen({ resume: mine.session_id })} data-testid="km-host-remote-resume">
          {t('remote.resume_host')}
        </button>
      ) : (
        <span className="km-host-remote">
          <button className="btn btn-sm btn-primary" disabled={!!block} aria-describedby={block ? 'km-remote-block' : undefined} onClick={() => setOpen({})} data-testid="km-host-remote">
            {t('remote.host_btn')}
          </button>
          {block && (
            <span id="km-remote-block" className="muted km-sub" data-testid="km-host-remote-block" data-block={block}>
              {' '}
              {t(`remote.block.${block}`)}
            </span>
          )}
        </span>
      )}
      {open && (
        <RemoteDialog
          target={target}
          resumeSessionId={open.resume}
          onClose={() => {
            setOpen(null);
            void q.refetch();
          }}
        />
      )}
    </>
  );
}
